import { createAction } from 'redux-actions';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import { notForPreview } from '../../../utils/not-for-preview';
import { sendBiEvent } from '../../../bi/send-bi-event';
import { openFullScreenSubscribeOverlay } from '../../../utils/open-overlay';
import {
  logChannelCoverButtonClicked,
  logSubscriptionPopupClosed,
} from '../../../components/player-overlay/bi';
import { createProxy } from '../../../worker/lib';

const OPEN_SUBSCRIPTION = 'CLIENT.PLAYER_OVERLAY.OPEN_SUBSCRIPTION';
const openSubscriptionAction = createAction(OPEN_SUBSCRIPTION);

export const openSubscription = createProxy(
  'openSubscription',
  (panoramaClient) => (dispatch, getState) => {
    const state = getState();
    const channelData = getChannelForWidget(state);

    notForPreview(() => {
      dispatch(sendBiEvent('widget.subscription.clicked'));
      dispatch(logChannelCoverButtonClicked('subscribe'));

      dispatch(
        openFullScreenSubscribeOverlay(panoramaClient, channelData.id, () =>
          dispatch(logSubscriptionPopupClosed()),
        ),
      );
    })();

    dispatch(openSubscriptionAction());
  },
);
